import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { doc, getDoc, setDoc, updateDoc,  addDoc, collection } from "firebase/firestore";
import { db, storage, auth } from "../firebaseConfig";
// import logo from "./link.png";
// import logo from "./Asset/NEW YORK LOGO-04.jpg";
import { Button, Upload, message, Tooltip } from "antd";
import firebase from "../firebaseConfig";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { signInWithGoogle } from "../firebaseConfig";
import { FcGoogle } from "react-icons/fc";
import logo from "./Asset/log.png";
import log from "./Asset/nfc.png";
import vid from "./Asset/read.mp4"



const SetUp = () => {
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [Show, setShow] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  // const { uid, email, usernames } = location.state || {};  // Destructure email as well
  const [error, setError] = useState(null);
  const currentUser = auth.currentUser;
  const currentURL = `${window.location.origin}/`;
  const [loading, setLoading] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  
  const [profileData, setProfileData] = useState(null);

  // const { username } = location.state || {};

  const [email, setEmail] = useState("");
  // const [status, setStatus] = useState("");
  const [isLinkSent, setIsLinkSent] = useState(false);
    
  const [user, setUser] = useState(null);

  const [CSuser, setCSUser] = useState();

  useEffect(() => {
    // Check if user data exists in local storage
    const userData = localStorage.getItem("userData");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup the event listener on unmount
  }, []);

  const writeToNFC = async () => {
    try {
      // console.log(`${currentURL}${username || profileData?.username}`)
      // Check if Web NFC is supported
      if (typeof window !== "undefined" && "NDEFReader" in window) {
        const ndef = new window.NDEFReader();

  
        // Start NFC session
        await ndef.write(`${currentURL}${username || profileData?.username}` || "Hello, NTAG DNA 424!");
  
        setStatus("Data written successfully to the NFC tag!");
        navigate("/profile");

      } else {
        setStatus("Please register by tapping the V-Train Logo on your garment like below");
        // setStatus("Web NFC is not supported in this browser.");
      }
    } catch (error) {
      console.error("Error writing to NFC:", error);
      setStatus("Failed to write data to NFC tag.");
    }
  };




 

  // Configure action code settings for email link
  const actionCodeSettings = {
    url: "http://localhost:3000", // Replace with your app's URL
    handleCodeInApp: true,
  };

  // Send sign-in email
  const sendSignInEmail = async () => {
    if (!email) {
      setStatus("Please enter a valid email.");
      return;
    }

    setStatus("Sending email link...");
    try {
      await firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings);
      setStatus("Email link sent! Check your inbox.");
      setIsLinkSent(true);

      // Save email to localStorage to complete the sign-in process later
      window.localStorage.setItem("emailForSignIn", email);
    } catch (error) {
      console.error("Error sending email link:", error);
      setStatus("Failed to send email link. Please try again.");
    }
  };

  // Complete sign-in when the link is clicked
  useEffect(() => {
    const completeSignIn = async () => {
      if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
        let email = window.localStorage.getItem("emailForSignIn");

        if (!email) {
          // Ask the user for their email if not stored
          email = window.prompt("Please confirm your email to sign in.");
        }

        try {
          const userCredential = await firebase.auth().signInWithEmailLink(email, window.location.href);
          setStatus(`Sign-in successful! Welcome, ${userCredential.user.email}`);
          window.localStorage.removeItem("emailForSignIn");
        } catch (error) {
          console.error("Error completing sign-in:", error);
          setStatus("Failed to complete sign-in. Please try again.");
        }
      }
    };

    completeSignIn();
  }, []);


  const handleGoogleSignIn = async () => {
    const user = await signInWithGoogle();
    if (user) {
      const { email, uid, displayName } = user;
  
      try {
        const userRef = doc(db, "userss", uid);
        const userDoc = await getDoc(userRef);
  
        if (userDoc.exists()) {
          // User already exists, navigate to profile
          // navigate("/profile", { state: { uid } });
          setShow(!Show)
        } else {
          // Create user profile in Firestore
          await setDoc(userRef, {
            email: email,
            name: displayName,
            uid: uid,
            createdAt: new Date(),
            username: "", // Placeholder for username
            balance: 0,
          });
  
          // Predefined titles and logos for the Links sub-collection
          const linksData = [
            { name: "Website", image: "https://cdn4.iconfinder.com/data/icons/small-n-flat/24/globe-512.png" },
            { name: "Instagram", image: "https://cdn2.iconfinder.com/data/icons/social-icons-33/128/Instagram-512.png" },
            { name: "PayPal", image: "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/250_Paypal_logo-512.png" },
            { name: "Facebook", image: "https://cdn1.iconfinder.com/data/icons/logotypes/32/square-facebook-512.png" },
            { name: "TikTok", image: "https://cdn0.iconfinder.com/data/icons/logos-brands-7/512/TikTok_logo_app0-512.png" },
            { name: "Zelle", image: "https://play-lh.googleusercontent.com/F4U2pL8z-Ic5FzCfe1xVXMWRvff6oEBIzDsyGRc4mE3bIUPiCfhuXXXvTOfcpVglKqs" },
            { name: "LinkedIn", image: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Linkedin_unofficial_colored_svg-512.png" },
            { name: "CashApp", image: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Square_Cash_app_logo.svg/1200px-Square_Cash_app_logo.svg.png" },
            { name: "X", image: "https://freepnglogo.com/images/all_img/1725374683twitter-x-logo.png" },
            { name: "WhatsApp", image: "https://cdn2.iconfinder.com/data/icons/social-media-applications/64/social_media_applications_23-whatsapp-512.png" },
            { name: "Youtube", image: "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/395_Youtube_logo-512.png" },
            { name: "VCard Link", image: "https://cdn2.iconfinder.com/data/icons/interface-vol-2-1/16/link-chain-hyperlink-web-512.png" },
            { name: "Link", image: "https://cdn2.iconfinder.com/data/icons/interface-vol-2-1/16/link-chain-hyperlink-web-512.png" },
            { name: "Link", image: "https://cdn2.iconfinder.com/data/icons/interface-vol-2-1/16/link-chain-hyperlink-web-512.png" },
            { name: "Link", image: "https://cdn2.iconfinder.com/data/icons/interface-vol-2-1/16/link-chain-hyperlink-web-512.png" },
          ];
  
          // Reference to the Links sub-collection
          const linksCollectionRef = collection(db, "userss", uid, "Links");
  
          // Add each title as a document with auto-generated ID
          for (const link of linksData) {
            await addDoc(linksCollectionRef, {
              name: link.name,
              url: "", // Placeholder for the URL
              image: link.image, // Logo URL
              createdAt: new Date(),
            });
          }
  
          // Navigate to username input screen
          setShow(!Show)
          // navigate("/username-input", { state: { uid } });
        }
      } catch (error) {
        console.error("Error handling user sign-in:", error);
      }
    }
  };
  
   // fetch the user data from firebase
   useEffect(() => {
    const subscriber = db
        .collection('userss')
        .doc(currentUser?.uid)
        .onSnapshot(documentSnapshot => {
          setProfileData(documentSnapshot.data());
        });
    
    // Stop listening for updates when no longer required
    return () => subscriber();
  }, [currentUser, profileData]);

  const [username, setUsername] = useState("");

  const handleSaveUsername = async () => {
    setStatus('Loading..')
    const finalUsername = username || profileData?.username;
  
    // Validate that we have a username and user ID
    if (!currentUser?.uid || !finalUsername) {
      setError("Please provide a valid username.");
      return;
    }
  
    try {
      // Check if the username is already taken
      const usedUsernameDoc = await getDoc(doc(db, "usedUsernames", finalUsername));
      if (usedUsernameDoc.exists() && usedUsernameDoc.data()?.uid !== currentUser.uid) {
        setError("Username is already taken. Please choose a different one.");
        return;
      }
  
      // Save the username in the user's document
      await updateDoc(doc(db, "userss", currentUser.uid), {
        username: finalUsername
      });
  
      // Add the username to the usedUsernames collection to reserve it
      await setDoc(doc(db, "usedUsernames", finalUsername), {
        uid: currentUser.uid,
        timestamp: new Date()
      });
  
      // Call the image upload handler if defined
      // if (typeof handleImageUpload === "function") {
      //   await handleImageUpload();
      // }
  
      writeToNFC()
      // Navigate to the profile screen
    } catch (error) {
      console.error("Error updating username:", error);
      setError("An error occurred while saving your username.");
    }
  };

  const launchNFCScanner = async () => {
    try {
      if (typeof window !== "undefined" && "NDEFReader" in window) {
        const ndef = new window.NDEFReader();
        setStatus("Activating NFC scanner...");
  
        // Start scanning
        await ndef.scan();
  
        // Success
        setStatus("NFC scanner is ready. Tap a tag to proceed.");
      } else {
        setStatus("NFC scanning is not supported on this device/browser.");
      }
    } catch (error) {
      console.error("Error launching NFC scanner:", error.message, error);
      setStatus(`Error: ${error.message || "Failed to activate NFC scanner."}`);
    }
  };
  
    

  

  return (
    <>
    {
      !user ?
      <div className="min-h-screen items-center dark:bg-black dark:text-white  flex flex-col justify-center text-center bg-white">
      {/* Image visible in dark mode */}
      <img src={log} className="hidden dark:inline w-60" alt="Dark Mode Logo" />
    
      {/* Image visible in light mode */}
      <img src={logo} className="inline dark:hidden w-60" alt="Light Mode Logo" />

      {/* <div className="flex flex-col items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md p-6 bg-white shadow-lg rounded-md">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Email OTP Sign-In</h2>
        
        {!isLinkSent ? (
          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">Email Address:</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button
              onClick={sendSignInEmail}
              className="w-full py-2 px-4 bg-blue-500 text-white font-medium rounded-md hover:bg-blue-600 transition duration-300"
            >
              Send Email Link
            </button>
          </div>
        ) : (
          <p className="text-center text-gray-700">
            An email link has been sent to <strong>{email}</strong>. Click the link to complete the sign-in process.
          </p>
        )}

        {status && (
          <p className="mt-4 text-center text-sm text-gray-600 bg-gray-200 px-4 py-2 rounded-md">
            {status}
          </p>
        )}
      </div>
    </div> */}

          <button onClick={handleGoogleSignIn} className="px-10 shadow-lg py-3 mt-10 bg-gray-200 text-gray-700 rounded-full">
            <FcGoogle className="inline mr-2" size={30} /> Continue with Google
          </button>
          <p onClick={() => alert("Please use google for now")} className="text-sm mb-4 mt-5 cursor-pointer">Other login options</p>
        </div>
              :
     <div className="min-h-screen flex flex-col justify-center p-3 items-center dark:bg-black dark:text-white bg-white">

{/* {status && <p className="lg:pt-24 pt-10"></p>} */}

    {/* <img src={logo} className="w-40 -mt-16 text-start" alt="" /> */}

      {/* Image visible in dark mode */}
  {/* <img src={log} className="hidden dark:inline w-60 -mt-20 lg:-mt-0" alt="Dark Mode Logo" /> */}

{/* Image visible in light mode */}
{/* <img src={logo} className="inline dark:hidden w-60 -mt-20 lg:-mt-0" alt="Light Mode Logo" /> */}

{
        profileData?.username &&
        <>

    <h2 className="text-2xl dark:text-white font-bold mb-1"> Click Finish to complete your NFC Setup</h2>
    <p className="mx-5 text-sm  mb-5 text-gray-400">Make Friends. Earn Points. Claim Rewards.</p>
        </>

}
      {
        !profileData?.username &&
      <>
      <h2 className="text-2xl dark:text-white font-bold mb-2 mt-20">Choose Username. To complete your NFC Setup</h2>
      <p className="mx-5 text-sm text-gray-400">Make Friends. Earn Points. Claim Rewards.</p>

      <input
        type="text"
        value={`${currentURL}${username}`}
        onChange={(e) => setUsername(e.target.value.replace(currentURL, ""))}
        placeholder="Enter your username"
        className="px-4 py-2 mb-4 mt-5 dark:text-white dark:bg-[#111] h-12 border w-80 outline-blue-400 rounded-lg"
        />
        </>
      }

      {error && <p className="text-red-500">{error}</p>}
      <button onClick={handleSaveUsername} className="px-6 py-3 bg-gradient-to-r from-amber-600 to-yellow-600 w-60 mb-3 text-white rounded-full">
        {status === "Loading.." ? "Loading.." : "Finish"}
      </button>
      {status === "Loading.." ? null : <p className="text-red-500 px-5">{status}


      {status && (
        <div className="mt-5 text-center justify-center items-cente self-center grid">
          {/* <p className="text-lg text-gray-700">{status}</p> */}
          {(status.includes("Please") || status.includes("Failed")) && (
            <div className="">
              {/* <p className="text-sm text-yellow-700 mb-2">Tap your NFC-enabled device or tag here</p> */}
              {/* <div className="w-12 h-12 mx-auto bg-yellow-400 rounded-full animate-pulse"></div> */}

              <div
  // style={{width: '100%'}}
  className="w-[100%] lg:h-[480px] justify-center items-center"
  dangerouslySetInnerHTML={{
    __html: `<video  style="
    width: 100%;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 100%;
    display: flex;
  align-items: center;
  align-self: center;
    object-fit: cover;
    border-radius: 10px;
    // z-index: -1;" 
    autoplay loop muted playsinline>
    <source src=${vid} type="video/mp4" />
    Your browser does not support the video tag.
    </video>`
  }}
  // <source src=${"https://web-video-resource.gentlemonster.com/assets/stories/jentle-salon/teasing/main/video-src-pc.mp4"} type="video/mp4" />
/> 

{/* <p className=" px-5">Launch </p> */}
              {/* <button onClick={launchNFCScanner} className="px-6 py-3 bg-gradient-to-r from-blue-600 to-yellow-600 w-60 mt-3 text-white rounded-full">
              Launch NFC Reader
      </button> */}
      <br />
      <button onClick={() => navigate('/profile')} className="px-6 py-2 mt-2 mb-5 dark:text-white text-black w-60 border-2  rounded-full">
        Skip
      </button>
            </div>
          )}
        </div>
      )}

        {/* {status} */}
        </p>}
    </div>
    }
    {/* <div style={{ padding: "20px" }}>
      <h1>NFC Writer</h1>
      <input
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Enter message to write"
        style={{ padding: "10px", marginRight: "10px", width: "300px" }}
        />
      <button onClick={writeToNFC} style={{ padding: "10px 20px" }}>
        Write to NFC Tag
      </button>
      {status && <p>Status: Please register by tapping your own badge {status}</p>}
    </div> */}
        </>
  );
};

export default SetUp;
